export enum WhatsAppMessageTypes {
    TEXT = 'text',
    REACTION = 'reaction',
    IMAGE = 'image',
    LOCATION = 'location',
    CONTACTS = 'contacts',
    INTERACTIVE = 'interactive',
    TEMPLATE = 'template',
}
